import { __ } from "@wordpress/i18n"
import { 
  useBlockProps, 
  InspectorControls
} from "@wordpress/block-editor"
import { 
  PanelBody,
  Notice
} from "@wordpress/components"

export default function Edit({ attributes, setAttributes }) {
  const blockProps = useBlockProps({
    className: "emergency-banner"
  })

  // Get site globals (available via wp_localize_script)
  const siteGlobals = window.siteGlobals || {}

  // Everything comes from site globals with hardcoded fallbacks - completely uneditable
  const displayData = {
    locationName: siteGlobals.name || 'PuroClean',
    phoneNumber: siteGlobals.phone || '(800) 775-7876',
    localWebsiteUrl: siteGlobals.website || '#',
    localWebsiteText: 'Visit Local Website',
    changeLocationText: 'Change Location'
  }

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Emergency Banner (Site Globals)', 'puroclean')} initialOpen={true}>
          <Notice status="info" isDismissible={false}>
            <p>
              <strong>This block displays desktop emergency banner only</strong><br />
              Mobile sticky CTA is automatically added to all pages via footer.<br />
              <br />
              <strong>Current Values:</strong><br />
              Location: {displayData.locationName}<br />
              Phone: {displayData.phoneNumber}<br />
              Website: {displayData.localWebsiteUrl}
            </p>
          </Notice>
          
          <Notice status="warning" isDismissible={false}>
            <p>
              To modify any content, update your Site Globals settings.<br />
              This ensures consistency across all emergency banners site-wide.
            </p>
          </Notice>
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        {/* Emergency Banner Section (Desktop Only) */}
        <div className="bg-primary-700 text-white w-full py-6">
          <div className="container max-w-content mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
              
              {/* Left Column - Location Info */}
              <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
                <p className="~text-16/xl font-semibold mb-2">
                  {displayData.locationName}
                </p>
                
                <div className="flex flex-col sm:flex-row items-center gap-4">
                  <a href={displayData.localWebsiteUrl} className="text-white hover:underline transition-all duration-200 ~text-14/base">
                    {displayData.localWebsiteText}
                  </a>
                  <button 
                    type="button"
                    className="text-white hover:underline transition-all duration-200 bg-transparent border-none cursor-pointer ~text-14/base"
                    onClick={() => alert('Location change functionality would go here')}
                  >
                    {displayData.changeLocationText}
                  </button>
                </div>
              </div>
              
              {/* Right Column - Phone Number */}
              <div className="flex items-center">
                <a 
                  href={`tel:${displayData.phoneNumber.replace(/[^0-9]/g, '')}`}
                  className="~text-24/5xl text-white hover:underline transition-all duration-200 font-bold"
                >
                  {displayData.phoneNumber}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
} 